// CORE
import React from 'react';
import PropTypes from 'prop-types';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 78,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.applyOpacityToHex(theme.palette.greyScale[7], 0)}`,
    borderBottom: `1px solid ${theme.palette.greyScale[5]}`,
  },
  bold: {
    fontWeight: 500,
  },
  light: {
    color: theme.palette.greyScale[2],
  },

}));

function SkeletonRow(props) {
  const { string1, string2, posted } = props;
  const classes = useStyles({posted});

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.bold}>
        {string1}
      </Typography>
      <Typography variant="body2" className={classes.light}>
        {string2}
      </Typography>
    </div>
  );
}
SkeletonRow.defaultProps = {
  string1: '',
  string2: '',
};

SkeletonRow.propTypes = {
  string1: PropTypes.string,
  string2: PropTypes.string,
  posted: PropTypes.bool,
};

export default SkeletonRow;
